/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Title_LabelInputs */

const vi_media_title_label = /** @type {(inputs: Media_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề`)
};

/**

* @param {Media_Title_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_title_label = /** @type {((inputs?: Media_Title_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Title_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_title_label(inputs)
});